import { newStepValue } from '../../../../services/flowBuilder/utils/constants';
import { formBuilderConstants } from '../../formbuilder';

const results = {
  success: {
    next: newStepValue,
    description: 'Authentication Successful',
  },
  error: {
    next: newStepValue,
    description: 'Authentication Failed',
  },
};

const oauth2 = {
  json: {
    menu: {
      menuType: 'authenticate',
      menuHeader: '',
      name: '',
      imageRef: '',
      menuParams: {
        mandatoryAuthenticate: false,
        actionType: 'authenticate',
        successfulResponseMessage: '',
        authProvider: '',
        oauth2: {
          scope: [],
          responseType: '',
        },
        authType: "oauth2"
      },
      results: results,
    },
    type: 'menu',
    metadata: {},

  },
  paths: [
    'menu.imageRef',
    'menu.menuParams.actionType',
    'menu.menuHeader',
    'menu.name',
    'menu.menuParams.successfulResponseMessage',
    'menu.menuParams.authProvider',
    'menu.menuParams.oauth2.scope',
    'menu.menuParams.oauth2.responseType',
    'menu.menuParams.mandatoryAuthenticate',
    'menu.results.#',
  ],
  groups: [
    {
      Parameters: [
        'menu.imageRef',
        'menu.menuParams.actionType',
        'menu.menuHeader',
        'menu.name',
        'menu.menuParams.successfulResponseMessage',
        'menu.menuParams.authProvider',
        'menu.menuParams.oauth2.scope',
        'menu.menuParams.oauth2.responseType',
        'menu.menuParams.mandatoryAuthenticate',
      ],
    },
    {
      Logic: ['menu.results.#'],
    },
  ],
};

const oauth = {
  json: {
    menu: {
      menuType: 'authenticate',
      menuHeader: '',
      name: '',
      imageRef: '',
      menuParams: {
        actionType: 'authenticate',
        successfulResponseMessage: '',
        authProvider: '',
        mandatoryAuthenticate: false,
        authType: "oauth"
      },
      results: results,
    },
    type: 'menu',
    metadata: {},
  },
  paths: [
    'menu.imageRef',
    'menu.menuParams.actionType',
    'menu.menuHeader',
    'menu.name',
    'menu.menuParams.successfulResponseMessage',
    'menu.menuParams.authProvider',
    'menu.menuParams.mandatoryAuthenticate',
    'menu.results.#',
  ],
  groups: [
    {
      Parameters: [
        'menu.imageRef',
        'menu.menuParams.actionType',
        'menu.menuHeader',
        'menu.name',
        'menu.menuParams.successfulResponseMessage',
        'menu.menuParams.authProvider',
        'menu.menuParams.mandatoryAuthenticate',
      ],
    },
    {
      Logic: ['menu.results.#'],
    },
  ],
};

const logout = {
  json: {
    menu: {
      menuType: 'authenticate',
      menuHeader: '',
      name: '',
      imageRef: '',
      menuParams: {
        actionType: 'logout',
        successfulResponseMessage: '',
        authProvider: '',
      },
      results: results,
    },
    type: 'menu',
    metadata: {},
  },
  paths: [
    'menu.imageRef',
    'menu.menuParams.actionType.',
    'menu.menuHeader',
    'menu.name',
    'menu.menuParams.successfulResponseMessage',
    'menu.menuParams.authProvider',
    'menu.results.#',
  ],
  groups: [
    {
      Parameters: [
        'menu.imageRef',
        'menu.menuParams.actionType',
        'menu.menuHeader',
        'menu.name',
        'menu.menuParams.successfulResponseMessage',
        'menu.menuParams.authProvider',
      ],
    },
    {
      Logic: ['menu.results.#'],
    },
  ],
};

const logoutOAuth2 = {
  json: {
    menu: {
      menuType: 'authenticate',
      menuHeader: '',
      name: '',
      imageRef: '',
      menuParams: {
        actionType: 'logout',
        successfulResponseMessage: '',
        authProvider: '',
        oauth2: {
          scope: [],
          responseType: '',
        },
      },
      results: results,
    },
    type: 'menu',
    metadata: {},
  },
  paths: [
    'menu.imageRef',
    'menu.menuParams.actionType',
    'menu.menuHeader',
    'menu.name',
    'menu.menuParams.successfulResponseMessage',
    'menu.menuParams.authProvider',
    'menu.menuParams.oauth2.scope',
    'menu.menuParams.oauth2.responseType',
    'menu.results.#',
  ],
  groups: [
    {
      Parameters: [
        'menu.imageRef',
        'menu.menuParams.actionType',
        'menu.menuHeader',
        'menu.name',
        'menu.menuParams.successfulResponseMessage',
        'menu.menuParams.authProvider',
        'menu.menuParams.oauth2.scope',
        'menu.menuParams.oauth2.responseType',
      ],
    },
    {
      Logic: ['menu.results.#'],
    },
  ],
};

export const Auth = {
  json: {
    menu: {
      menuType: 'authenticate',
      menuHeader: '',
      name: '',
      imageRef: '',
      menuParams: {
        mandatoryAuthenticate: false,
        actionType: '',
        successfulResponseMessage: '',
        authProvider: '',
        authType: "oauth2",
        oauth2: {
          scope: [],
          responseType: '',
        },
      },
      results: results,
    },
    type: 'menu',
    metadata: {},
  },
  paths: [
    'menu.imageRef',
    'menu.menuParams.actionType',
    'menu.menuHeader',
    'menu.name',
    'menu.menuParams.successfulResponseMessage',
    'menu.menuParams.authProvider',
    'menu.menuParams.oauth2.scope',
    'menu.menuParams.oauth2.responseType',
    'menu.menuParams.mandatoryAuthenticate',
  ],
  groups: [
    {
      Parameters: [
        'menu.imageRef',
        'menu.menuParams.actionType',
        'menu.menuHeader',
        'menu.name',
        'menu.menuParams.successfulResponseMessage',
        'menu.menuParams.authProvider',
        'menu.menuParams.oauth2.scope',
        'menu.menuParams.oauth2.responseType',
        'menu.menuParams.mandatoryAuthenticate',
      ],
    },
    {
      Logic: ['menu.results.#'],
    },
  ],
  layout: {
    name: {
      type: 'text',
      label: 'Name',
      validators: {
        required: true,
        spaceOnName: true,
      },
    },
    menuHeader: {
      type: 'text',
      label: 'Title',
      validators: {
        required: true,
        spaceOnName: false,
      },
    },
    imageRef: {
      type: 'image',
      label: '',
      validators: {
        required: false,
        spaceOnName: true,
      },
    },
    actionType: {
      type: 'actionType',
      label: 'Type',
      attributes: {
        buttons: [
          {
            text: 'Authenticate',
            value: 'authenticate',
          },
          {
            text: 'Logout',
            value: 'logout',
          },
        ],
        data: true,
      },
    },
    successfulResponseMessage: {
      type: 'text',
      label: 'Successful Response Message',
      validators: {
        required: true,
        spaceOnName: false,
      },
    },
    authProvider: {
      type: 'dropdown',
      label: 'Auth Provider',
      attributes: {
        options: {
        },
        data: true,
      },
      validators: {
        optionSelected: true,
        required: true,

      },
    },
    scope: {
      dataType: 'array',
      type: 'chips',
      label: 'Scope',
      validators: {
        required: true,
        spaceOnName: false,
        duplicate: false,
      },
    },
    responseType: {
      type: 'text',
      label: 'Response Type',
      validators: {
        required: true,
        spaceOnName: true,
      },
    },
    results: {
      dataType: 'keyObject',
      key: {
        attributes: {
          readonly: true,
        },
        type: 'text',
        label: '#',
      },
      value: {
        description: {
          type: 'text',
          label: 'Description',
          attributes: {
            readonly: true,
          },
        },
        next: {
          type: 'next',
          label: 'Point to',
        },
      },
    },
    next: {
      type: 'next',
      label: 'Next',
      validators: {
        optionSelected: true,
      },
    },
    mandatoryAuthenticate: {
      type: 'checkbox-single',
      label: 'Mandatory Authentication',
      attributes: {
        options: {
          true: 'true',
          false: 'false',
        },
        data: true,
      },
    },
  },
  data: {
    dataPath: 'menu.menuParams.authType',
    authType: {
      logout: {
        logoutOAuth2: logoutOAuth2,
        '-': logout,
      },
      authenticate: {
        oauth: oauth,
        'oauth2': oauth2,
      },
    },
    results: {
      next: newStepValue,
      description: '',
    },
  },
};
